import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { hasUserValidRoleGroupLevel } from "@utils/access-control/group/group-access-control";
import { RequiredRoleGroupLevelName } from "@utils/access-control/group/group-access-control-types";
/** Checks whether a user has permission for an action on group level or not */
export function useHasUserValidRoleGroupLevel(t0) {
  const $ = _c(21);
  const {
    selectedGroup
  } = t0;
  const currentUser = useAppSelector(currentUserSelector);
  let t1;
  if ($[0] !== currentUser || $[1] !== selectedGroup) {
    t1 = hasUserValidRoleGroupLevel({
      currentUser,
      roleName: RequiredRoleGroupLevelName.canEditGroupDetails,
      selectedGroup
    });
    $[0] = currentUser;
    $[1] = selectedGroup;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const canEditGroupDetails = t1;
  let t2;
  if ($[3] !== currentUser || $[4] !== selectedGroup) {
    t2 = hasUserValidRoleGroupLevel({
      roleName: RequiredRoleGroupLevelName.canInviteUsersToGroup,
      currentUser,
      selectedGroup
    });
    $[3] = currentUser;
    $[4] = selectedGroup;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const canInviteUsersToGroup = t2;
  let t3;
  if ($[6] !== currentUser || $[7] !== selectedGroup) {
    t3 = hasUserValidRoleGroupLevel({
      roleName: RequiredRoleGroupLevelName.canResendInvitationToGroup,
      currentUser,
      selectedGroup
    });
    $[6] = currentUser;
    $[7] = selectedGroup;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const canResendInvitationToGroup = t3;
  let t4;
  if ($[9] !== currentUser || $[10] !== selectedGroup) {
    t4 = hasUserValidRoleGroupLevel({
      currentUser,
      roleName: RequiredRoleGroupLevelName.canEditMember,
      selectedGroup
    });
    $[9] = currentUser;
    $[10] = selectedGroup;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const canEditMember = t4;
  let t5;
  if ($[12] !== currentUser || $[13] !== selectedGroup) {
    t5 = hasUserValidRoleGroupLevel({
      currentUser,
      roleName: RequiredRoleGroupLevelName.canDeleteMemberFromGroup,
      selectedGroup
    });
    $[12] = currentUser;
    $[13] = selectedGroup;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const canDeleteMemberFromGroup = t5;
  let t6;
  if ($[15] !== canDeleteMemberFromGroup || $[16] !== canEditGroupDetails || $[17] !== canEditMember || $[18] !== canInviteUsersToGroup || $[19] !== canResendInvitationToGroup) {
    t6 = {
      canEditGroupDetails,
      canInviteUsersToGroup,
      canResendInvitationToGroup,
      canEditMember,
      canDeleteMemberFromGroup
    };
    $[15] = canDeleteMemberFromGroup;
    $[16] = canEditGroupDetails;
    $[17] = canEditMember;
    $[18] = canInviteUsersToGroup;
    $[19] = canResendInvitationToGroup;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}